<template>
    <div>
        <b-table hover small responsive show-empty
            :id="slug"
            :fields="fields"
            :items="items"
            primary-key="mdhTrackingId"
            :busy="isLoading"
            :per-page="perPage"
            :current-page="currentPage"
            :filter="filter"
            @filtered="onFiltered"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc">
            <template v-slot:cell(actions)="row">
                <b-button size="sm" @click="editItem(row.item)" class="mr-1">
                edit
                </b-button>
            </template>
            <template v-slot:cell(mdhTrackingId)="data">
                <span>{{ data.item.mdhTrackingId }}</span>
                <span v-if="data.item.jobId" style="font-size:.90em;">
                    <br/> {{ data.item.jobId }}
                </span>
            </template>

            
            <template v-slot:no-data>
                <v-btn color="primary" @click="initialize">Reset</v-btn>
            </template>

            <template v-slot:empty="scope">
                <p>No requests found.</p>
            </template>

            <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle" style="margin-right:5px; margin-top:12px;"></b-spinner>
                <strong>Loading, Please Wait...</strong>
            </div>  
        </b-table>
      <b-pagination
          v-if="this.items.length > perPage"
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="fill"
          size="sm"
          class="my-0"/>
    </div>
</template>

<script>
import SecureLS from "secure-ls";

export default {
    components: {
    },
    props: {
        items: Array,
        slug: [String],
        isLoading: Boolean,
        filter: String,
    },
    data: () => ({
      perPage: 15,
      currentPage: 1,
      totalRows: 0,

      sortBy: 'mdhTrackingId',
      sortDesc: false,

        fields: [
        ],
    }),
    created() {
        this.buildFields()
        if (typeof this.$store.state.searchSortDetails[this.slug] !== "undefined") {
          this.sortBy = this.$store.state.searchSortDetails[this.slug].sortBy
        }
        if(typeof this.$store.state.searchSortDetails[this.slug] !== "undefined"){
          this.sortDesc = this.$store.state.searchSortDetails[this.slug].sortDesc
        }
        this.setTotalRows(this.items.length)
    },
    computed: {
    },
    methods: {
      onFiltered(filteredItems) {
        this.setTotalRows(filteredItems.length)
        this.currentPage = 1
      },
      setTotalRows(total){
        this.totalRows = total
      },
        editItem(item) {
            let searchSortDetails = {'key': this.slug, 'settings': {'sortBy': this.sortBy, 'sortDesc': this.sortDesc}}
            this.$store.dispatch('loadSearchSortDetails', searchSortDetails)
            this.saveSearchResults(this.slug, this.items)
            this.$emit('editRequest')
            this.$router.push({ name: 'view', params: { id: item.id } })
        },

        buildFields() {
            this.fields.push({key: 'mdhTrackingId', sortable: true, label: 'Number'})
            this.fields.push({key: 'leaveType', sortable: true, label: 'Leave Type'})
            this.fields.push({key: 'divisionCode', sortable: true, label: 'Division'})
            this.fields.push({key: 'anticipatedStartDate', sortable: true, label: 'Start'})
            this.fields.push({key: 'endDate', sortable: true, label: 'End'})
            this.fields.push({key: 'certificationDeadline', sortable: true, label: 'Certification'})
            this.fields.push({key: 'formattedStatus', sortable: true, label: 'Lifecycle Status'})
            this.fields.push({key: 'payrollTransactionAction', sortable: true, label: 'Payroll/Transaction Actions'})
            this.fields.push({key: 'lastUpdatedDateTime', sortable: true, label: 'Last Updated Date'})

            this.fields.push({key: 'employeeName', sortable: true, label: 'Employee Name'})
        
            this.fields.push({key: 'supervisorName', sortable: true, label: 'Supervisor'})
            this.fields.push({key: 'actions', label: 'Actions'})
        },
        saveSearchResults(slug, searchResults){
          if(slug === 'search'){
            console.log("We are saving search results!")
            var ls = new SecureLS({ isCompression: false });
            ls.set('hrm-request-search-results', searchResults)
          }
        }
    },
    watch: {
      items: function(){
        this.setTotalRows(this.items.length)
      }

    }
}
</script>